import React, { useState } from "react";
import { DeleteProgramModalProps } from "@shared/interfaces/ProgramFiles";

const DeleteProgramModal: React.FC<DeleteProgramModalProps> = ({
  isOpen,
  selectedProgram,
  onClose,
  onConfirm,
}) => {
  const [deleteInput, setDeleteInput] = useState("");

  if (!isOpen) return null;

  return (
    <div className="fixed px-4 inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-[99]">
      <div className="bg-white rounded-lg shadow-xl py-4 px-2 mx-auto text-center">
        <img src="/thrash-bin.png" className="mb-3" alt="" />
        <h2 className="text-lg font-semibold text-gray-800">
          Are you sure you want to delete
          <br />
          <span className="font-bold">{selectedProgram?.name}</span>?
        </h2>

        <p className="text-gray-600 mt-3 text-sm">
          This action will delete all files and reports
          <br />
          related to the project. This cannot be undone.
        </p>

        <p className="text-gray-600 my-4 text-sm">
          To confirm, type <span className="font-semibold">DELETE</span> in the
          field below.
        </p>
        <div className="px-4">
          <input
            type="text"
            placeholder="Type here..."
            value={deleteInput}
            onChange={(e) => setDeleteInput(e.target.value)}
            className="w-full mt-2 p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400"
          />

          <div className="mt-4 flex justify-between">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-lg text-blue-600 border-blue-600 border-2 hover:bg-gray-100 transition w-full mr-2"
            >
              Cancel
            </button>
            <button
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onConfirm();
                setDeleteInput("");
              }}
              disabled={deleteInput !== "DELETE"}
              className={`px-4 py-2 w-full rounded-lg text-white transition ${
                deleteInput === "DELETE"
                  ? "bg-red-500 hover:bg-red-600"
                  : "bg-gray-300 cursor-not-allowed"
              }`}
            >
              Delete Program
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteProgramModal;
